<template>
    <div class="loader-container-page">
        <span class="loader-page"></span>
        <span class="blinking">
            <slot />
        </span>
    </div>
</template>

<script>
    export default {
        name: "Loader",
    }
</script>

<style></style>